import { Navigate } from 'react-router-dom'
import BaseLayout from 'layouts/BaseLayout'
import VendorList from 'pages/inventory/vendors'
import VendorForm from 'pages/inventory/vendors/VendorForm'
import StockLocation from 'pages/inventory/stockLocation'
import Pricelists from 'pages/inventory/stockLocation/pricelists'
import PricelistForm from 'pages/inventory/stockLocation/pricelists/PricelistForm'
import ProductHome from 'pages/inventory/sub-pages/product/ProductHome'
import CategoryHome from 'pages/inventory/sub-pages/category/CategoryHome'

export default function InventoryRoutes() {
  return {
    path: 'inventory',
    children: [
      {
        path: '',
        element: <Navigate to="/inventory/vendors" />,
      },
      {
        path: 'vendors',
        element: (
          <BaseLayout title="Daftar Vendor">
            <VendorList />
          </BaseLayout>
        ),
      },
      {
        path: 'vendors/create',
        element: (
          <BaseLayout title="Tambah Vendor" isBackNav={true}>
            <VendorForm />
          </BaseLayout>
        ),
      },
      {
        path: 'vendors/:id',
        element: (
          <BaseLayout title="Ubah Vendor" isBackNav={true}>
            <VendorForm />
          </BaseLayout>
        ),
      },
      {
        path: 'stock-location',
        element: (
          <BaseLayout title="Kelola Lokasi">
            <StockLocation />
          </BaseLayout>
        ),
      },
      {
        path: 'stock-location/stock/:id',
        element: (
          <BaseLayout title="Kelola Stok & Harga" isBackNav={true}>
            <Pricelists />
          </BaseLayout>
        ),
      },
      {
        path: 'stock-location/stock/:id/pricelist/create',
        element: (
          <BaseLayout title="Tambah Stok & Harga" isBackNav={true}>
            <PricelistForm />
          </BaseLayout>
        ),
      },
      {
        path: 'stock-location/stock/:id/pricelist/edit',
        element: (
          <BaseLayout title="Ubah Stok & Harga" isBackNav={true}>
            <PricelistForm />
          </BaseLayout>
        ),
      },
      {
        path: 'products',
        element: (
          <BaseLayout title="Kelola Produk">
            <ProductHome />
          </BaseLayout>
        ),
      },
      {
        path: 'categories',
        element: (
          <BaseLayout title="Kelola Kategori">
            <CategoryHome />
          </BaseLayout>
        ),
      },
    ],
  }
}
